import React from "react";
import useStyles from "../styles";

const HoursView = ({selectedDay, useTime}) => {
    const cl = useStyles();
    const [selectedTime, setSelectedTime] = useTime;

    const handleClickOnTime = (e, time) => {
        e.preventDefault();
        e.stopPropagation();

        if (!time.free) return;

        setSelectedTime(time);
    };

    return (<div className={cl.daysWrapper}>
        <div className={cl.monthHeading}>
            <h1
                className={cl.monthHeadingText}
            >
                ВИБРАНИЙ ЧАС
            </h1>
            {selectedTime && <div className={cl.timeWrapperSelected}>
                {selectedTime.time}
            </div>}
        </div>
        <div className={cl.hoursWrapper}>
            {selectedDay.scheduler.map((time, idx) => {
                const className = time.free
                    ? selectedTime?.time === time.time
                        ? cl.timeWrapperSelected
                        : cl.timeWrapper
                    : cl.timeWrapperNotFree

                return (<div key={'time'+time.time+idx} className={className}
                             onClick={(e) => handleClickOnTime(e, time)}>
                    {time.time}
                </div>);
            })}
        </div>
    </div>);
};

export default HoursView;
